import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, MenuItem, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import AssignDriver_VehicleService from "src/service/assigndriverService";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Vehicle Assign to Driver",
  },
];

const validationSchema = yup.object({
  driver_name: yup.string("Driver name").required("Driver name is required"),
  vehicle_no: yup
    .string("Vehicle number")
    .required("Vehicle number is required"),
});

const UpdateAssignVehicleToDriver = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const param = useParams();
  const [drivers, setDrivers] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [selectedDriverName, setSelectedDriverName] = useState("");

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    driver_name: "",
    vehicle_no: "",
    d_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const res = await AssignDriver_VehicleService.getAssignedDriver({
          id: param.id,
        });

        setDrivers(res.data);

        setInitialValues({
          id: param.id,
          driver_name: res.data[0].driver_name,
          vehicle_no: res.data[0].vehicle_no,
          d_by: sessionData.data.id,
        });

        setSelectedDriverName(res.data[0].driver_name);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchDriverData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        try {
          const res = await AssignDriver_VehicleService.updateAssignedDriver(
            values
          );

          if (res && res.success) {
            swal("Success", res.message, "success");
            navigate("/driver");
          } else {
            swal("Error", "Failed to update. Please try again.", "error");
          }
        } catch (error) {
          console.error("Update error:", error);
          swal("Error", "An error occurred. Please try again later.", "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Update Assign Driver" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Assign Driver
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/assignVehicleDriver");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "5px" }}>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="driver_name">
                Driver <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="driver_name"
                name="driver_name"
                value={values.driver_name}
                onChange={(event) => {
                  handleChange(event);
                  setSelectedDriverName(event.target.value);
                }}
                onBlur={handleBlur}
                error={touched.driver_name && Boolean(errors.driver_name)}
                helperText={touched.driver_name && errors.driver_name}
                fullWidth
                variant="outlined"
              >
                <MenuItem value="">Select</MenuItem>
                {drivers.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.driver_name}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <CustomFormLabel htmlFor="vehicle_no">
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="vehicle_no"
                name="vehicle_no"
                type="text"
                value={values.vehicle_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                helperText={touched.vehicle_no && errors.vehicle_no}
                variant="outlined"
                placeholder="Enter Vehicle No"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid
            item
            lg={6}
            md={12}
            sm={12}
            sx={12}
            style={{ marginTop: "20px" }}
          >
            <Button color="primary" variant="contained" type="submit">
              Submit
            </Button>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateAssignVehicleToDriver;
